var map = {
	"./IMG_4872.jpg": 2813,
	"./IMG_4877.jpg": 5412,
	"./IMG_4878.jpg": 2887,
	"./IMG_4880.jpg": 1054,
	"./IMG_4881.jpg": 5835,
	"./IMG_4884.jpg": 2922,
	"./IMG_4890.jpg": 1893,
	"./IMG_4892.jpg": 3559,
	"./IMG_4893.jpg": 1402,
	"./IMG_4898.jpg": 3485,
	"./IMG_4903.jpg": 3724,
	"./IMG_4906.jpg": 9253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8627;